import React from "react";
import QueueAnim from 'rc-queue-anim';
import './style.less'
import { Card, Row, Col } from 'antd';

const { Meta } = Card;

export default class MobileParametersContent extends React.Component {

    render() {
        return (
            <div className="mobile-gcs-description-container">
                <div className="description">
                    <div className='line'>
                        <Row>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/2screen.png" alt={""} />
                                    </div>
                                    <div className="line-box-item">
                                        <p>双屏设计航线与视频分开显示</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/controller.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>便携式带轮地面站箱可手提<br></br>防震防尘</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E6%8E%A7%E5%88%B6%E9%81%A5%E6%84%9F.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>内置云台控制摇杆,流畅精准</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/7H.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>7小时超长续航,足够全天使用</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/spreadControl.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>人体工学设计，合理分区操作<br></br>互不干扰</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E7%9C%9F%E7%9A%AE%E9%9D%A2%E6%9D%BF.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>真皮面板,舒适的操作体验</p>
                                    </div>
                                </div>
                            </Col>
                            <Col span="24" className="line-item">
                                <div className="line-box">
                                    <div className="line-box-item">
                                    <img src="http://qiniu.metridynamic.com/image/new-official-en/GCS/%E7%94%B5%E5%AD%90%E8%AE%BE%E5%A4%87%E5%85%85%E7%94%B5.png" alt={""} />

                                    </div>
                                    <div className="line-box-item">
                                        <p>地面站内置电池可为笔记本<br />电脑手机等电子设备充电</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

        )

    }
}
